
import { defineComponent } from 'vue';
import customModelMixin from '../mixins/custom-model';

export default defineComponent({
  name: 'BaseFormRadio',
  mixins: [customModelMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    option: {
      type: [String, Boolean],
      required: true
    }
  }
});
